import React, { Component } from 'react'
import { Route } from 'react-router-dom';

export const createRoute = (routes) => {
    return routes.map((route, index) => <Route exact={route.exact || true} path={route.path} component={route.component} key={index} />);
}
